// Montant qu'une facture présente au client, et écart avec son devis d'origine.
//
// Une facture de SOLDE porte les lignes complètes du devis : son `total_ttc` recouvre
// ce qui a déjà été facturé par les factures d'acompte. Afficher ce brut fait lire
// 5 000 + 3 000 + 12 000 = 20 000 € pour un devis de 12 000 €.
// Le montant à présenter est celui que le document facture réellement — même règle que
// `acomptes.due_amount()` côté serveur. `total_ttc` n'est jamais modifié : il garde sa
// place en base et sur le PDF.

const round2 = (v) => Math.round((v || 0) * 100) / 100;

export const acompteDeductedTtc = (doc) =>
  doc?.subtype === "solde"
    ? round2((doc.acompte_deductions || []).reduce((s, a) => s + Number(a.amount_ttc || 0), 0))
    : 0;

/** Montant réellement facturé par ce document (acomptes déjà émis déduits). */
export const billedTtc = (doc) => round2(Number(doc?.total_ttc || 0) - acompteDeductedTtc(doc));

/** Écart entre une facture de solde et son devis d'origine, ou null s'il n'y en a pas.
 *  `devis_total_ttc` vient du serveur (une requête pour toute la liste) : ne jamais
 *  aller chercher le devis document par document depuis le navigateur. */
export const devisMismatch = (doc) => {
  if (doc?.subtype !== "solde" || doc?.devis_total_ttc == null) return null;
  const devisTtc = Number(doc.devis_total_ttc);
  const docTtc = Number(doc.total_ttc || 0);
  if (Math.abs(docTtc - devisTtc) <= 0.01) return null;
  return { devisNumber: doc.devis_number || doc.source_doc_number || "", devisTtc, docTtc };
};
